(function () {
  'use strict';

  var SESSION_KEY = 'mirabaseOpeningSeen';
  var EXIT_MS = 500;

  var opening = document.querySelector('[data-mirabase-opening]');
  if (!opening) return;

  var skipButton = opening.querySelector('[data-mirabase-opening-skip]');
  var replayButton = opening.querySelector('[data-mirabase-opening-replay]');
  var logo = opening.querySelector('[data-mirabase-opening-logo]');

  var autoCloseMs = parseInt(opening.getAttribute('data-auto-close') || '4300', 10);
  if (Number.isNaN(autoCloseMs) || autoCloseMs < 1500) autoCloseMs = 4300;
  if (autoCloseMs > 12000) autoCloseMs = 12000;

  var showSkip = opening.getAttribute('data-show-skip') !== 'false';
  var designReplayEnabled = opening.getAttribute('data-design-replay') !== 'false';
  var designMode = document.documentElement.classList.contains('shopify-design-mode') || (window.Shopify && window.Shopify.designMode);
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var autoTimer = null;
  var exitTimer = null;
  var isClosing = false;

  function readSessionSeen() {
    try {
      return window.sessionStorage.getItem(SESSION_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function writeSessionSeen() {
    try {
      window.sessionStorage.setItem(SESSION_KEY, 'true');
    } catch (error) {}
  }

  function lockScroll() {
    document.body.classList.add('mirabase-opening-active');
  }

  function unlockScroll() {
    document.body.classList.remove('mirabase-opening-active');
  }

  function clearTimers() {
    if (autoTimer) {
      window.clearTimeout(autoTimer);
      autoTimer = null;
    }
    if (exitTimer) {
      window.clearTimeout(exitTimer);
      exitTimer = null;
    }
  }

  function restartLogoAnimation() {
    if (!logo) return;
    var clone = logo.cloneNode(true);
    logo.parentNode.replaceChild(clone, logo);
    logo = clone;
  }

  function finishOpening() {
    if (isClosing) return;
    isClosing = true;
    clearTimers();

    if (!designMode) {
      writeSessionSeen();
    }

    opening.classList.add('is-exiting');
    opening.setAttribute('aria-hidden', 'true');

    exitTimer = window.setTimeout(function () {
      unlockScroll();

      if (designMode && designReplayEnabled) {
        opening.classList.remove('is-exiting');
        opening.classList.add('is-design-idle');
        if (replayButton) {
          replayButton.hidden = false;
        }
      } else {
        opening.hidden = true;
        opening.classList.remove('is-exiting');
      }

      isClosing = false;
    }, EXIT_MS);
  }

  function startOpening() {
    clearTimers();
    isClosing = false;

    opening.hidden = false;
    opening.classList.remove('is-exiting', 'is-design-idle');
    opening.setAttribute('aria-hidden', 'false');

    if (replayButton) replayButton.hidden = true;

    restartLogoAnimation();
    lockScroll();

    var duration = reducedMotion ? 900 : autoCloseMs;
    autoTimer = window.setTimeout(finishOpening, duration);
  }

  function shouldPlayOnLoad() {
    if (designMode) {
      return true;
    }
    if (document.documentElement.classList.contains('mirabase-opening--already-seen')) {
      return false;
    }
    if (readSessionSeen()) {
      return false;
    }
    return true;
  }

  if (!showSkip && skipButton) {
    skipButton.hidden = true;
  }

  if (skipButton) {
    skipButton.addEventListener('click', finishOpening);
  }

  if (replayButton && designMode && designReplayEnabled) {
    replayButton.addEventListener('click', function () {
      try {
        window.sessionStorage.removeItem(SESSION_KEY);
      } catch (error) {}
      document.documentElement.classList.remove('mirabase-opening--already-seen');
      startOpening();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (opening.hidden || isClosing) return;
    finishOpening();
  });

  if (shouldPlayOnLoad()) {
    startOpening();
  } else {
    opening.hidden = true;
    opening.setAttribute('aria-hidden', 'true');
    unlockScroll();
  }

  if (designMode && designReplayEnabled && replayButton) {
    document.addEventListener('shopify:section:load', function () {
      if (!opening.hidden) return;
      replayButton.hidden = false;
      opening.classList.add('is-design-idle');
    });
  }
})();
